export const reset = (type) => {
  return {
    type: `${type}_RESET`,
  }
}
